import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgArrowMiniUp32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M21.354 18.957a.5.5 0 0 0 0-.707L16 12.897l-5.354 5.353a.5.5 0 0 0 .708.707L16 14.311l4.646 4.646a.5.5 0 0 0 .708 0" /></SvgIcon>;
};
const Memo = memo(SvgArrowMiniUp32);
export default Memo;